import { useEffect, useState } from 'react';
import ControlCenterOverview from '../components/dashboard/ControlCenterOverview';

const MOBILE_BREAKPOINT = 960;

function getInitialCompactMode() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= MOBILE_BREAKPOINT;
}

function OverviewView({
  boards,
  metrics,
  operations,
  performance,
  onSelectBoard,
  title,
  description
}) {
  const [compactMode, setCompactMode] = useState(getInitialCompactMode);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onResize = () => {
      setCompactMode(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <section data-ui-view="overview" data-ui-section="overview-view">
      <ControlCenterOverview
        boards={boards}
        metrics={metrics}
        operations={operations}
        performance={performance}
        onSelectBoard={onSelectBoard}
        title={title}
        description={description}
        compactMode={compactMode}
      />
    </section>
  );
}

export default OverviewView;
